import { Controller } from '@hotwired/stimulus'
import { formatMoneyFromCents, parseMoneyToCents } from '../lib/money.mjs'

export default class extends Controller {
  static targets = ['input', 'cents']

  connect() {
    if (this.centsTarget.value) this.format()
  }

  input() {
    this.syncCents()
    if (!this.centsTarget.value) return

    this.format()
    this.placeCaretBeforeDecimals()
  }

  blur() {
    this.syncCents()
    this.format()
  }

  submit() {
    this.syncCents()
  }

  syncCents() {
    const cents = parseMoneyToCents(this.inputTarget.value)
    this.centsTarget.value = cents ?? ''
  }

  format() {
    const formatted = formatMoneyFromCents(this.centsTarget.value)
    if (formatted) this.inputTarget.value = formatted
  }

  placeCaretBeforeDecimals() {
    const decimalSeparator = this.inputTarget.value.lastIndexOf(',')
    if (decimalSeparator >= 0) this.inputTarget.setSelectionRange(decimalSeparator, decimalSeparator)
  }
}
